import { render, staticRenderFns } from "./DarkReconDashboard.vue?vue&type=template&id=4fe5d0f9"
import script from "./DarkReconDashboard.vue?vue&type=script&lang=js"
export * from "./DarkReconDashboard.vue?vue&type=script&lang=js"
import style0 from "./DarkReconDashboard.vue?vue&type=style&index=0&id=4fe5d0f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports